export default function (value, sign = true, hasUnit = true) {
  if (value === null || value === undefined || Number.isNaN(value) || !Number.isFinite(value)) return '--'
  if (value === 0) return `0.00${hasUnit ? '%' : ''}`
  let rate = Math.abs(value) * 100
  rate = rate.toFixed(2)
  const s = sign
    ? value < 0
      ? '-'
      : '+'
    : ''
  return `${s}${rate}${hasUnit ? '%' : ''}`
}
